import React from 'react';
import { useNavigate } from 'react-router';
import { LockOutlined, LoginOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';
import { useSignIn } from '../../../../../hooks/useAuth';
import { AuthLayout } from '../../../components/Layout';

export const SignInForm = () => {
    const navigate = useNavigate();
    const { mutate, isPending, error } = useSignIn();
    const onFinish = (values) => mutate(values);

    return (
        <AuthLayout
            error={error}
            heading='Sign in with email'
            subheading='Use the admin credentials you were issued.'
            footer={
                <span className='auth-secondary'>
                    Prefer Google?{' '}
                    <Button type='link' onClick={() => navigate('/sign-in/google')}>
                        Back to Google sign-in
                    </Button>
                </span>
            }
        >
            <Form name='signin' layout='vertical' onFinish={onFinish} requiredMark={false}>
                <Form.Item
                    name='email'
                    label='Email'
                    rules={[
                        { type: 'email', message: 'Please enter a correct email address' },
                        { required: true, message: 'Please enter your email' }
                    ]}
                >
                    <Input
                        prefix={<UserOutlined aria-hidden='true' className='site-form-item-icon' />}
                        placeholder='you@klickly.com'
                        autoComplete='username'
                        inputMode='email'
                        size='large'
                    />
                </Form.Item>
                <Form.Item
                    name='password'
                    label='Password'
                    rules={[{ required: true, message: 'Please enter your password' }]}
                >
                    <Input.Password
                        prefix={<LockOutlined aria-hidden='true' className='site-form-item-icon' />}
                        placeholder='Password'
                        autoComplete='current-password'
                        size='large'
                    />
                </Form.Item>

                <Form.Item style={{ marginBottom: 0 }}>
                    <Button
                        size='large'
                        icon={<LoginOutlined aria-hidden='true' />}
                        type='primary'
                        htmlType='submit'
                        loading={isPending}
                        className='login-form-button'
                        block
                    >
                        Sign in
                    </Button>
                </Form.Item>
            </Form>
        </AuthLayout>
    );
};
